// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadButton {\r\n\tright: -76px;\r\n\tposition: absolute;\r\n\tz-index: 200;\r\n\ttop: 0px;\r\n\tborder-radius: 4px;\r\n\tmargin-top: 0px;\r\n\tbackground: #e2ffd5;\r\n\tmargin-bottom: 0;\r\n\theight: 30px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
